/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setRatePlan} from '../api'

export const useMutationSetRatePlan = createReactQueryMutationHook('setRatePlan', setRatePlan)
